import { useSelector } from 'react-redux';
import { getLocationBasedPhoneNumber } from '../util/ottawaLocation';

/**
 * Custom hook to get location-based phone number
 * @param {string} defaultPhoneNumber - Default phone number from environment
 * @returns {string} Phone number to display based on user location
 */
export const useLocationBasedPhoneNumber = (defaultPhoneNumber) => {
    const detectedCurrentLocation = useSelector(state => state.user?.currentUserLocationInfo);
    return getLocationBasedPhoneNumber(detectedCurrentLocation, defaultPhoneNumber);
};
